<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="product-upsell-overlay"
      @click.self="$emit('close')"
    >
      <div
        class="product-upsell-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="product-upsell-title"
      >
        <p id="product-upsell-title" class="product-upsell-message">
          {{ message }}
        </p>
        <div class="product-upsell-actions">
          <button
            type="button"
            class="product-upsell-btn"
            @click="$emit('close')"
          >
            Close
          </button>
          <button
            type="button"
            class="product-upsell-btn product-upsell-btn--primary"
            @click="$emit('learn-more')"
          >
            Learn more
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ProductUpsellPrompt',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'learn-more'],
}
</script>

<style scoped>
.product-upsell-overlay {
  position: fixed;
  inset: 0;
  background: rgba(33, 41, 56, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
  padding: 16px;
}
.product-upsell-dialog {
  background: #ffffff;
  border: 1px solid #d9e2ef;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(33, 41, 56, 0.18);
  max-width: 420px;
  width: 100%;
  padding: 22px 24px 20px;
}
.product-upsell-message {
  margin: 0 0 18px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
  color: #212938;
}
.product-upsell-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
}
.product-upsell-btn {
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  padding: 8px 14px;
  cursor: pointer;
  border: 1px solid #d9e2ef;
  background: #ffffff;
  color: #212938;
}
.product-upsell-btn--primary {
  background: #0059b2;
  border-color: #0059b2;
  color: #ffffff;
}
.product-upsell-btn--primary:hover {
  background: #0073e6;
  border-color: #0073e6;
}
</style>
